import { useRouter } from "next/router";
import { MouseEvent, useMemo } from "react";
import { getPipelineLink, getSource } from "lib/utils";
import { storageService, getPipelineLocalStorageData } from "lib/utils/localStorage";
import { PipelineRoutingLinkButtonProps } from "./types";

const usePipelineRoutingLink = ({
  href,
  onClick,
  sourceIdentifier = "",
}: Omit<PipelineRoutingLinkButtonProps, "children">) => {
  const { asPath } = useRouter();
  const source = getSource(asPath);

  const localStorageData = useMemo(() => {
    const data = {
      source: sourceIdentifier || source,
    };

    return getPipelineLocalStorageData({ asPath, data, nextPipelinePath: href });
  }, [asPath, href, source, sourceIdentifier]);

  const formattedHref = useMemo(() => getPipelineLink(href, localStorageData), [href, localStorageData]);

  const handleClick = (e: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);

    storageService.asyncSet(localStorageData.token, localStorageData);
  };

  return {
    href: formattedHref,
    onClick: handleClick,
  };
};

export { usePipelineRoutingLink };
